export { GlobalModal as default } from "./global-modal";
